import { Slider } from "@mui/material";
import { useEffect, useState } from "react";
import CustomMark from "./CustomMark";
import CustomMarkLabel from "./CustomMarkLabel";
import CustomThumb from "./CustomThumb";
import { ICancelable } from "./interfaces/CancelableInterface";
import { TemperatureSelectProps } from "./interfaces/TemperatureSelectProps";

const CustomSlider: React.FC<CustomSliderProps> = ({
  min,
  max,
  defaultValue,
  step,
  marks,
  getAriaValueText,
  temperatureValue,
  setTemperatureValue,
  debounceCall,
}) => {
  const [sliderValue, setSliderValue] = useState<number>(defaultValue);

  useEffect(() => {
    debounceCall(defaultValue);
  }, []);

  const handleChangeUsingTopLevelDebounce = (event: any, newValue: number) => {
    setSliderValue(newValue);
    debounceCall(newValue);
  };

  return (
    <div className="d-flex">
      <Slider
        min={min}
        max={max}
        defaultValue={defaultValue}
        value={sliderValue}
        track={false}
        step={step}
        marks={marks}
        valueLabelDisplay="off"
        getAriaValueText={getAriaValueText}
        onChange={(event, value) => {
          if (typeof value == "number") {
            /* setSliderValue(value); */

            handleChangeUsingTopLevelDebounce(event, value);
          }
        }}
        sx={{
          thumb: {
            pointerEvents: "none",
          },
        }}
        slots={{
          thumb: (props) => {
            return <CustomThumb value={sliderValue} {...props}></CustomThumb>;
          },
          mark: (props) => {
            return (
              <CustomMark
                dataIndex={props["data-index"]}
                min={min}
                max={max}
                marks={marks}
                style={props.style}
                {...props}
              ></CustomMark>
            );
          },
          markLabel: (props) => {
            return (
              <CustomMarkLabel
                dataIndex={props["data-index"]}
                style={props.style}
                {...props}
              ></CustomMarkLabel>
            );
          },
        }}
        className="custom-slider"
      ></Slider>
    </div>
  );
};

export default CustomSlider;

export interface CustomSliderProps extends TemperatureSelectProps {
  min: number;
  max: number;
  defaultValue: number;
  step: number;
  marks: Mark[];
  getAriaValueText: (value: number) => string;
  debounceCall: ((newValue: number) => void) & ICancelable;
}

export interface Mark {
  value: number;
  label: string;
}
